var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 4.54416C8.11232 4.54416 5.54208 4.70592 3.90992 4.82487C3.36787 4.86438 2.94807 5.29346 2.94807 5.81755V6.40976L9.48052 9.84095C9.80318 10.0104 10.1955 10.0104 10.5182 9.84095L17.0506 6.40976V5.81754C17.0506 5.29346 16.6308 4.86438 16.0888 4.82487C14.4566 4.70592 11.8863 4.54416 9.99935 4.54416ZM17.0506 7.79638L11.1408 10.9005C10.4309 11.2734 9.56777 11.2734 8.85785 10.9005L2.94807 7.79638V14.1799C2.94807 14.7039 3.36787 15.133 3.90992 15.1725C5.54208 15.2914 8.11232 15.4533 9.99935 15.4533C11.8863 15.4533 14.4566 15.2914 16.0888 15.1725C16.6308 15.133 17.0506 14.7039 17.0506 14.1799V7.79638ZM3.81138 3.61634C5.44452 3.49731 8.05825 3.33203 9.99935 3.33203C11.9404 3.33203 14.5542 3.49731 16.1873 3.61634C17.4078 3.70529 18.3327 4.67026 18.3327 5.81754V14.1799C18.3327 15.3271 17.4078 16.2921 16.1873 16.381C14.5542 16.5001 11.9404 16.6654 9.99935 16.6654C8.05825 16.6654 5.44452 16.5001 3.81138 16.381C2.59087 16.2921 1.66602 15.3271 1.66602 14.1799V5.81755C1.66602 4.67027 2.59087 3.70529 3.81138 3.61634Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.535da06a8d8d51e6b4e6ffbe06100170.svg";
export { ForwardRef as ReactComponent };